module.exports = __webpack_public_path__ + "images/marketing.2ae684bb.svg";